import { useRef } from 'react';
import Button from 'components/CncUI/Button';

const UploadImageButton = props => {
  const upload = useRef();
  const {
    id = 'UploadButton',
    children,
    accept = '.pdf',
    disabled = false,
    onChange = () => {},
    ...other
  } = props;

  const checkFile = e => {
    const { target: { validity, files: [file] = [] } = {} } = e || {};
    if (!validity.valid) {
      upload.current.value = null;
      return;
    }
    try {
      const reader = new FileReader();
      reader.onload = () =>
        onChange({
          error: '',
          file: reader.result,
          fileName: file.name,
          fileType: file.type,
        });
      reader.onerror = err => {
        upload.current.value = null;
        onChange({
          error: err.message,
          file: null,
          fileName: null,
          fileType: null,
        });
      };
      reader.readAsDataURL(file);
    } catch {
      upload.current.value = null;
    }
  };

  if (disabled) {
    return (
      <Button id={id} {...other} component="span" disabled>
        {children}
      </Button>
    );
  }

  return (
    <>
      <input
        id={`${id}-File`}
        type="file"
        accept={accept}
        onChange={checkFile}
        style={{ display: 'none' }}
        ref={upload}
      />
      <label htmlFor={`${id}-File`}>
        <Button id={id} {...other} component="span">
          {children}
        </Button>
      </label>
    </>
  );
};

export default UploadImageButton;
